const steps = [
  {
    icon: "ri-message-3-line",
    title: "1. Apply Online",
    description: "Start your application on our secure checkout. Select your processing speed (24h to 2–3 weeks).",
  },
  {
    icon: "ri-mail-send-line",
    title: "2. Ship Documents",
    description: "Send your forms, photo, and old passport (if renewing) to our registered courier office via overnight shipping.",
  },
  {
    icon: "ri-shield-check-line",
    title: "3. We Review & Submit",
    description: "A dedicated agent checks for errors, then submits your application at a U.S. passport agency with reserved courier slots.",
  },
  {
    icon: "ri-truck-line",
    title: "4. Passport Delivered",
    description: "Your new passport is mailed directly to your Idaho Falls address. Track progress with daily updates from your agent.",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            Get Your Passport in 4 Simple Steps
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-base leading-relaxed">
            From Idaho Falls to any passport agency — we handle the logistics so you don&apos;t have to.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="bg-[#0F2440] rounded-lg p-6 border border-[#F6C344]/20">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/10 mb-4">
                <i className={`${step.icon} text-[#F6C344] text-xl`}></i>
              </div>
              <h3 className="font-bold text-white text-sm mb-2">{step.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}